import React, { PureComponent } from 'react';

import {
    View,
    Image,
    StyleSheet,
} from 'react-native'
import {
    JDText,
    JDImage,
    JDTouchable
} from '@jdreact/jdreact-core-lib'

import { pt, px } from '../../common/utils';
import { promoTxt } from '../../common/enum';
export default class ScaleInfo extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let { promoTypes } = this.props;
        return (
            <View style={[st.info]}>
                <View style={st.item_title}>
                    <JDText style={st.title}>优惠促销</JDText>
                </View>
                {
                    promoTypes.map((val, index) => {
                        return (
                            <View style={st.item} key={index + ''}>
                                <View style={st.v_tip}>
                                    <View style={st.v_scale}>
                                        <JDText style={[st.tip, st.scale]}>惠</JDText>
                                    </View>
                                    <JDText style={st.i_text}>{promoTxt[val.promoType].txt}</JDText>
                                </View>
                                <JDText style={st.i_price}>&yen;{val.promoPrice/100}元</JDText>
                            </View>
                        )
                    })
                }
                {/* <View style={st.item}>
                    <View style={st.v_tip}>
                        <View style={st.v_scale}>
                            <JDText style={[st.tip, st.scale]}>惠</JDText>
                        </View>
                        <JDText style={st.i_text}>新人专享套餐充值1000送500券</JDText>
                    </View>
                    <JDText style={st.i_price}>-&yen;10</JDText>
                </View>
               <View style={st.item}>
                    <View style={st.v_tip}>
                        <JDText style={[st.tip,st.quan]}>券</JDText>
                        <JDText style={st.i_text}>新人专享套餐充值1000送500券</JDText>
                    </View>
                   <JDText style={st.i_price}>-&yen;10</JDText>
               </View> */}
            </View>
        )
    }
}

const st = StyleSheet.create({
    info: {
        backgroundColor: '#fff',
        padding: pt(10),
        borderBottomColor: 'rgba(0,0,0,.1)',
        borderBottomWidth: px(1),
        paddingBottom: pt(20)
    },
    item_title: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: pt(5),
        paddingTop: pt(8),
        alignItems: 'center'
    },
    item: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: pt(40),
        paddingHorizontal: pt(5),
        alignItems: 'center'
    },
    title: {
        fontSize: pt(18),
        height: pt(35)
    },
    i_text: {
        fontSize: pt(14),
        color: 'rgb(37,37,37)',
        flexDirection: 'row',
    },
    i_price: {
        fontSize: pt(14),
        color: '#E2231A'
    },
    price_big: {
        fontSize: pt(20),
        fontWeight: 'bold'
    },
    border_top: {
        borderTopColor: 'rgba(0,0,0,.1)',
        borderTopWidth: px(1),
        paddingTop: pt(10),
        alignItems: 'center',
        marginTop: pt(5),
    },
    v_tip: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    v_scale: {
        height: pt(15),
        width: pt(14),
        backgroundColor: '#F56A00',
        borderRadius: pt(2),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: pt(2)
    },
    scale: {
        color: '#fff',
        fontSize: pt(10),
    },
    card: {
        color: '#fff',
        backgroundColor: '#2B84FF'
    },
    quan: {
        color: '#fff',
        backgroundColor: '#27BD4E'
    },
})